import { css, styled } from '@volkswagen-onehub/components-core';

export const DisclaimerFeatureContainer = styled.div<{ $isModal?: boolean }>`
  padding: ${({ $isModal }) =>
    $isModal ? '14px 64px 14px 24px' : '14px 24px 6px 24px'};
  background-color: ${({ theme }) => theme.colors.tab.stepnav.selected};
  border-radius: 8px;

  ${({ $isModal }) =>
    !$isModal &&
    css`
      margin-top: 0.5rem;
    `}

  max-height: ${({ $isModal }) => ($isModal ? '200px' : 'none')};
  overflow-y: ${({ $isModal }) => ($isModal ? 'auto' : 'visible')};
`;
